export enum CookieName {
  AUTH = "auth",
  REFRESH = "refresh",
}
